import script from "./ManualViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManualViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ManualViewer.vue?vue&type=style&index=0&id=79543b53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79543b53"]])

export default __exports__